import React from 'react';
import { styled } from 'styled-components';
import { H2, P2 } from '../../../styles/textTags';
import { BREAKPOINTS, COLORS } from '../../../styles/variables';

const About = ({ data }) => {
  return (
    <AboutWr>
      <H2>О спектакле</H2>
      <P2>{data}</P2>
    </AboutWr>
  );
};

const AboutWr = styled.div`
  color: ${COLORS.black};

  display: flex;
  flex-direction: column;
  align-items: start;

  gap: 20px;

  @media ${BREAKPOINTS.laptop} {
    gap: 1.39vw;
  }

  @media ${BREAKPOINTS.mobile} {
    gap: 4.17vw;
  }
`;

export default About;
